<h1>{{ 'Report_Archive_tr' | translate }}</h1>

@if (company && site) {
  <div style="margin-bottom: 1em">
    {{ 'please_find_archived_compliance_tr' | translate }}
    <button type="button" mat-stroked-button class="inline-button" [routerLink]="['/company', company.id, 'site', site.id, 'chain']">
      {{ 'supply_chain_tr' | translate }}
      <mat-icon>arrow_outward</mat-icon>
    </button>
    {{ 'or_continue_with_an_existing_review_tr' | translate }}
    <button type="button" mat-stroked-button class="inline-button" [routerLink]="['/company', company.id, 'site', site.id, 'evaluation']">
      {{ 'Draft_Reviews_tr' | translate }}
      <mat-icon>arrow_outward</mat-icon>
    </button>
  </div>
}

@if (company && site) {
  <form class="filter" [formGroup]="form">
    <div>
      @if (form.value.chain) {
        <mat-chip-row [class.chain-deleted]="form.value.chain.id === chainDeleted?.id" (removed)="form.controls.chain.reset()">
          {{ form.value.chain.name }}
          <button type="button" matChipRemove>
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip-row>
      }
    </div>
    <mat-form-field appearance="fill">
      <mat-label>{{ 'Search_tr' | translate }}</mat-label>
      <input formControlName="search" matInput />
      <button type="submit" mat-icon-button matSuffix>
        <mat-icon>search</mat-icon>
      </button>
    </mat-form-field>
  </form>
}

@if (chainDeleted) {
  <app-info-text role="status" data-testid="chain-gone-hint">
    {{ (list.length === 0 ? 'chain_gone_tr' : 'chain_gone_archives_tr') | translate }}
  </app-info-text>
}

<mat-table [dataSource]="list">
  <ng-container matColumnDef="name">
    <mat-cell *matCellDef="let e">
      <div class="block">
        <div style="font-weight: bold">{{ e.name }}</div>
        <div>{{ e.product }}</div>
        <div style="font-style: italic">{{ e.norm.name }}</div>
        <div style="color: #888">
          Created: {{ e._created | date: 'yyyy-MM-dd' }}
          @if (e.startDate || e.endDate) {
            <div style="color: #888">
              Validity:
              {{ e.startDate ? (e.startDate | date: 'yyyy-MM-dd') : '—' }}
              -
              {{ e.endDate ? (e.endDate | date: 'yyyy-MM-dd') : '—' }}
            </div>
          }
          <div style="color: #888">
            @if (e.totalAreaHa) {
              {{ 'Total_Area_tr' | translate }}: {{ e.totalAreaHa | number: '1.2-2' }}ha
            } @else {
              <span style="font-style: italic; color: #aaa">{{ 'Total_Area_tr' | translate }}: {{ 'Not_available_tr' | translate }}</span>
            }
            @if (e.species && e.species.length > 0) {
              {{ 'species_tr' | translate }}:
              <app-species-names [codes]="e.species" />
            } @else {
              <span style="font-style: italic; color: #aaa">{{ 'species_tr' | translate }}: {{ 'Not_available_tr' | translate }}</span>
            }
          </div>
          <div
            class="id-copy"
            (click)="$event.stopPropagation(); copyToClipboard(e.id)"
            (keydown.enter)="$event.stopPropagation(); copyToClipboard(e.id)"
            (keydown.space)="$event.stopPropagation(); copyToClipboard(e.id)"
            [title]="'Copy ID to clipboard'"
            tabindex="0"
            role="button"
          >
            ID: {{ e.id }}
          </div>
        </div>
        <!--
          Bottom-left of the row. Shows only what was frozen with the report (E3): no
          hasGeoJson/hasSpecies here, because a report written before this feature has nothing
          frozen and must not be given a verdict after the fact.
        -->
        @let sd = siteData(e);
        <app-site-data-badge [producer]="true" [hasSpecies]="sd.hasSpecies" [findings]="sd.findings" [severe]="sd.severe" />
        @if (e.migrationStatus) {
          <app-migration-status [status]="e.migrationStatus" [error]="e.migrationError"></app-migration-status>
        }
      </div>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="edit">
    <mat-header-cell *matHeaderCellDef></mat-header-cell>
    <mat-cell *matCellDef="let e">
      <button
        type="button"
        (click)="$event.stopPropagation(); downloadPdf(e)"
        mat-icon-button
        color="primary"
        [title]="'download_pdf_report_tr' | translate"
      >
        <mat-icon>description</mat-icon>
      </button>
      <span
        class="admin-action"
        data-testid="download-zip-complete"
        [title]="(authService.isAdmin ? 'download_zip_archive_tr' : 'download_zip_archive_admin_only_tr') | translate"
      >
        <button
          type="button"
          (click)="$event.stopPropagation(); downloadZip(e)"
          mat-icon-button
          color="primary"
          [disabled]="!authService.isAdmin"
        >
          <mat-icon>folder</mat-icon>
          <mat-icon class="admin-badge" data-testid="admin-badge">shield</mat-icon>
        </button>
      </span>
      <button
        type="button"
        data-testid="download-zip-customer"
        (click)="$event.stopPropagation(); downloadCustomerZip(e)"
        mat-icon-button
        color="primary"
        [title]="'download_zip_customer_tr' | translate"
      >
        <mat-icon>folder_shared</mat-icon>
      </button>
      <button
        type="button"
        (click)="$event.stopPropagation()"
        mat-icon-button
        [routerLink]="[e.id]"
        color="primary"
        [title]="'edit_tr' | translate"
      >
        <mat-icon>edit</mat-icon>
      </button>
    </mat-cell>
  </ng-container>
  <mat-row *matRowDef="let row; columns: ['name', 'edit']; let e" (click)="preview(e)"></mat-row>
</mat-table>

<app-paginator />
